import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFolderDetailParams,
  GetFolderDetailResponse,
} from './types';

export const getFolderDetail = async ({
  folder_sno,
  last_sno,
  order,
  category_sno,
  delivery_type_list,
}: GetFolderDetailParams) => {
  return defaultHttpClient
    .request<GetFolderDetailResponse>(
      {
        method: 'GET',
        url: `/api/v2/members/me/liked_folders/${folder_sno}/`,
        params: {
          last_sno,
          order,
          category_sno,
          delivery_type_list,
        },
      },
      {
        arrayFormat: 'repeat',
      },
    )
    .then(result => result.data);
};
